<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{ translate('incomingDoc.address') }}</label>
            <div class="col">
                <input type="text" v-model="value.Path" class="form-control" required maxlength="300" />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{ translate('targetSystem.ftp.username') }}</label>
            <div class="col">
                <input v-model="value.Credential.Username" type="text" class="form-control" />
            </div>
        </div>

        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{ translate('targetSystem.ftp.passcode') }}</label>
            <div class="col">
                <password v-model="value.Credential.Password" class="form-control" @change="$forceUpdate()" />
            </div>
        </div>
    </div>
</template>

<script>
import password from '@/components/Password.vue'

export default {
    components: {
        password
    },
    props: ['value'],
    data() {
        return {

        }
    },
    methods: {

    }
}

</script>
